export default "/_next/static/chunks/fonts/pxiByp8kv8JHgFVrLEj6Z1xlFQ-d4e54a8767fc7a098f4aae66e142841a.woff2";